import FlightEnquiry from './FlightEnquiry'

export default FlightEnquiry
